import React from "react";
import QRCode from "react-qr-code";
import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/Done';
import useLzFApiCall from "@lz-services/Api";
import ImgFbrDILogo from "../../../assets/images/fbr-di-logo.jpg";
import SalesInvoiceModel from "./sales-invoice.model";

const SalesInvoiceFBRSubmissionComponent = (props) => {

    const apiCall = useLzFApiCall();

    const submit = async () => {
        const data = await apiCall('sales-invoices/fbr-submit/' + (+(props.data?.id || 0)));
        if (data) {
            if (props.onChange) {
                const updated = new SalesInvoiceModel(props.data);
                updated.fbr_invoice_no = data;
                props.onChange(updated);
            }
        }
    };

    if (typeof props.data !== 'undefined' && props.data.id < 1) {
        return <div style={{ paddingTop: 8 }}>n/a</div>;
    }

    return (
        <div style={{ paddingTop: props.detailed ? 18 : 0 }}>

            {'' === props.fbrInvoiceNo ?
                <React.Fragment>
                    <Button type="button" size="small" color="success" onClick={() => submit()}>Try Now</Button>
                </React.Fragment>
                :
                <React.Fragment>
                    {props.detailed ?
                        <div style={{ position: 'absolute', left: 20, top: 32, display: 'flex' }}>
                            <img src={ImgFbrDILogo} alt="FBR Digital Invoicing Logo" style={{ marginRight: 12, width: 72, height: 'auto' }} />
                            <div style={{ width: 72, height: 72 }}>
                                <QRCode value={props.fbrInvoiceNo} style={{ width: '100%', height: '100%' }} />
                            </div>
                        </div>
                        :
                        <React.Fragment>
                            <DoneIcon sx={{ verticalAlign: 'bottom' }} /> Done!
                        </React.Fragment>
                    }
                </React.Fragment>
            }

        </div>
    );

};

export default SalesInvoiceFBRSubmissionComponent;
